import { render, staticRenderFns } from "./Deduplicates.vue?vue&type=template&id=0b386f02"
import script from "./Deduplicates.vue?vue&type=script&lang=js"
export * from "./Deduplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports